import React from 'react';
import { CreditCard, CheckCircle } from 'lucide-react';

export const PaymentSettingsTab: React.FC = () => {
  return (
    <div className="space-y-5 text-left">
      {/* Stripe Payments */}
      <div className="rounded-2xl border border-strivre-lightnavy bg-white p-6 shadow-sm">
        <div className="flex items-start gap-3">
          <div className="rounded-xl bg-strivre-lightburgundy p-2 text-strivre-burgundy">
            <CreditCard size={18} />
          </div>

          <div className="flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <h4 className="font-semibold text-slate-900">
                Stripe Payments
              </h4>

              <span className="rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-700">
                Coming Soon
              </span>
            </div>

            <p className="mt-1 text-sm text-slate-500">
              Accept online invoice payments securely through your
              business Stripe account.
            </p>
          </div>
        </div>

        {/* Coming Soon State */}
        <div className="mt-5 rounded-2xl border border-amber-200 bg-amber-50 p-5">
          <div className="flex items-start gap-3">
            <div className="rounded-xl bg-amber-100 p-2 text-amber-700">
              <CreditCard size={18} />
            </div>

            <div className="flex-1">
              <h5 className="font-semibold text-amber-900">
                Stripe integration is coming soon
              </h5>

              <p className="mt-2 text-sm leading-6 text-amber-800">
                We're working on enabling Stripe payments so you can
                connect your business Stripe account and accept invoice
                payments directly through Strivre Services.
              </p>

              <p className="mt-2 text-sm leading-6 text-amber-800">
                Once available, you'll be able to configure Stripe here
                and offer secure online payment options to your clients.
              </p>

              <button
                type="button"
                disabled
                className="mt-4 inline-flex cursor-not-allowed items-center gap-2 rounded-xl bg-slate-200 px-4 py-2 text-sm font-semibold text-slate-500"
              >
                <CreditCard size={16} />
                Connect Stripe
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Planned Stripe Features */}
      <div className="rounded-2xl border border-strivre-lightburgundy bg-strivre-lightburgundy p-5">
        <h4 className="font-semibold text-strivre-burgundy">
          What's coming with Stripe?
        </h4>

        <p className="mt-2 text-sm leading-6 text-slate-700">
          Stripe integration will provide a streamlined way to collect
          and track invoice payments through Strivre Services.
        </p>

        <div className="mt-4 grid gap-3 sm:grid-cols-2">
          <div className="rounded-xl border border-white/60 bg-white/60 p-4">
            <div className="flex items-start gap-3">
              <CheckCircle
                size={18}
                className="mt-0.5 shrink-0 text-strivre-burgundy"
              />

              <div>
                <p className="text-sm font-semibold text-slate-900">
                  Online invoice payments
                </p>

                <p className="mt-1 text-xs leading-5 text-slate-600">
                  Give clients a convenient way to pay invoices online.
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-white/60 bg-white/60 p-4">
            <div className="flex items-start gap-3">
              <CheckCircle
                size={18}
                className="mt-0.5 shrink-0 text-strivre-burgundy"
              />

              <div>
                <p className="text-sm font-semibold text-slate-900">
                  Direct Stripe payments
                </p>

                <p className="mt-1 text-xs leading-5 text-slate-600">
                  Payments will be processed through your connected
                  business Stripe account.
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-white/60 bg-white/60 p-4">
            <div className="flex items-start gap-3">
              <CheckCircle
                size={18}
                className="mt-0.5 shrink-0 text-strivre-burgundy"
              />

              <div>
                <p className="text-sm font-semibold text-slate-900">
                  Automatic payment tracking
                </p>

                <p className="mt-1 text-xs leading-5 text-slate-600">
                  Keep invoice payment statuses synchronized after
                  successful payments.
                </p>
              </div>
            </div>
          </div>

          <div className="rounded-xl border border-white/60 bg-white/60 p-4">
            <div className="flex items-start gap-3">
              <CheckCircle
                size={18}
                className="mt-0.5 shrink-0 text-strivre-burgundy"
              />

              <div>
                <p className="text-sm font-semibold text-slate-900">
                  Secure hosted checkout
                </p>

                <p className="mt-1 text-xs leading-5 text-slate-600">
                  Clients will complete payment through a secure
                  Stripe-hosted checkout experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};